import { Box, Skeleton } from "@mui/material";
import HomeSegmentTitle from "../HomeSegmentTitle";
import LyricsOutlinedIcon from "@mui/icons-material/LyricsOutlined";
import HomeSegmentCard from "../HomeSegmentCard";
import HomeSegmentContent from "../HomeSegmentContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const rows = [...Array(7)].map(() => ({
    skeleton: (
      <Skeleton
        variant="rounded"
        height={20}
        sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
      />
    ),
}));

const InterviewTemplateSkeleton = () => {
  return (
    <HomeSegmentCard>
      <HomeSegmentTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LyricsOutlinedIcon /> Interview Templates
        </Box>
      </HomeSegmentTitle>

      <HomeSegmentContent>
        <TableContainer component={Paper}>
          <Table  aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="center">Owner</TableCell>
                <TableCell align="center">Last Modified</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
            {rows.map((row,index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell component="th" scope="row">
                  {row.skeleton}
                </TableCell>
                <TableCell align="center">{row.skeleton}</TableCell>
                <TableCell align="center">{row.skeleton}</TableCell>
              </TableRow>
               ))}
            </TableBody>
          </Table>
        </TableContainer>
      </HomeSegmentContent>
    </HomeSegmentCard>
  );
};

export default InterviewTemplateSkeleton;
